<div class="card settings-page branding-page">
  <div class="action-panel">
    @if (currentPageMode == BrandingPageModes.Preview || currentPageMode == BrandingPageModes.NoLogo) {
      <button
        *appHasRole="['Admin', 'Manager']"
        id="edit-branding-btn"
        type="button"
        class="btn btn-primary d-flex align-items-center gap-2"
        [disabled]="isLoading()"
        (click)="startEditBranding()"
      >
        <i class="icon ic-edit-20"></i>
        <span>Edit Branding</span>
      </button>

    } @else if (currentPageMode == BrandingPageModes.Edit) {
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="isLoading()"
        (click)="saveChanges()"
      >
        Save
      </button>

      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="isLoading()"
        (click)="cancelEditing()"
      >
        Cancel
      </button>
    }
  </div>

  <div class="branding-page-content">
    @if (currentPageMode == BrandingPageModes.Preview || currentPageMode == BrandingPageModes.Edit) {
      <div class="preview-variant-control">
        <app-radio
          [formControl]="previewVariantControl"
          [options]="previewVariants"
        />
      </div>
    }

    @if (currentPageMode == BrandingPageModes.Loading) {
      <app-loader [loading]="currentPageMode == BrandingPageModes.Loading && isLoading()"/>
    } @else if (currentPageMode == BrandingPageModes.NoLogo) {
      <div class="no-logos">
        <i class="icon ic-info-circle-20"></i>
        <span>No logo is available at the moment. Please upload a logo.</span>
      </div>
    } @else if (currentPageMode == BrandingPageModes.Preview) {
      <div class="view-content">
        <div class="template-wrapper">
          <ng-container
            [ngTemplateOutlet]="previewTemplate"
            [ngTemplateOutletContext]="{ logo: logoImg, footerText: organisationBrandModel.footerText }"
          />
        </div>

        <div class="description">
          <div class="form-group mb-0">
            <label class="title mb-1">Brand Name</label>
            <div class="property">
              <div appCopy>{{ organisationBrandModel.brandName | defaultValue }}</div>
            </div>
          </div>

          <div class="form-group mb-0">
            <label class="title mb-1">Cover Page Footer Text</label>
            <div class="property">
              <div appCopy>{{ organisationBrandModel.footerText | defaultValue }}</div>
            </div>
          </div>

          <div class="form-group mb-0">
            <label class="title mb-1">Brand Color</label>

            <div class="property color-template-wrapper">
              <span class="color-template preview" [style.background]="organisationBrandModel.mainColor"></span>
              <span>
                <div appCopy>{{ organisationBrandModel.mainColor | defaultValue }}</div>
              </span>
            </div>
          </div>

          <div class="form-group mb-0">
            <label class="title mb-1">Insert Logo in the Annual Statement Cover Letter</label>
            <div class="property">
              {{ organisationBrandModel.insertLogoInAnnualStatementCoverLetter ? 'Yes' : 'No' }}
            </div>
          </div>

          <div class="form-group mb-0">
            <label class="title mb-1">Add a Cover Page on ASIC forms</label>
            <div class="property">
              {{ organisationBrandModel.addCoverPageOnAsicForms ? 'Yes' : 'No' }}
            </div>
          </div>
        </div>
      </div>
    } @else if (currentPageMode == BrandingPageModes.Edit) {
      <form class="view-content" (ngSubmit)="saveChanges($event)">
        <button type="submit" hidden [disabled]="isLoading()"></button>

        <div class="preview-container">
          <div class="template-wrapper">
            <ng-container
              [ngTemplateOutlet]="previewTemplate"
              [ngTemplateOutletContext]="{ logo: url, footerText: editModeFooterText }"
            />
          </div>
        </div>

        <div class="description" [formGroup]="form">
          <div class="form-group mb-0">
            <app-input
              label="Brand Name"
              formControlName="brandName"
            />
          </div>

          <div class="form-group mb-0">
            <app-select
              label="Cover Page Footer Text"
              formControlName="coverPageFooterTextVariant"
              [options]="coverPageFooterTextOptions"
              [valuePrimitive]="true"
            />
          </div>

          @if (form.controls.coverPageFooterTextVariant.value === CoverPageFooterTextVariant.CustomFooterText) {
            <div class="form-group mb-0">
              <app-input
                label="Custom Footer Text"
                formControlName="footerText"
              />
            </div>
          }

          <div class="form-group mb-0 file-control-palette">
            <div class="file-control">
              <div class="header">Brand Logo</div>

              <input
                #fileUploadInput
                style="display: none"
                type="file"
                [multiple]="false"
                [accept]="acceptedFormats"
                [disabled]="isLoading()"
                (change)="handleFileInputEvent($event)"
              >

              @if (url) {
                <div class="file-label">
                  <div class="icon-text">
                    <i class="icon ic-file-16"></i>
                    <span>logo.png</span>
                  </div>

                  <app-ag-action-icon-button
                    iconClass="ic-trash-16"
                    [disabled]="isLoading()"
                    (action)="clearFiles()"
                  />
                </div>

              } @else {
                <button
                  type="button"
                  class="btn btn-secondary d-flex align-items-center gap-2"
                  [disabled]="isLoading()"
                  (click)="fileUploadInput.click()"
                >
                  <i class="icon ic-upload-file-20"></i>
                  <span>Upload New Logo</span>
                </button>
              }
            </div>

            <div class="palette">
              <app-color-picker
                label="Brand Color"
                formControlName="mainColor"
                [fullWidth]="true"
                [hideRandom]="true"
                [colors]="brandColors"
              />
            </div>
          </div>

          <app-disclaimer
            icon="ic-info-circle-20"
            color="light-gray"
          >
            <div class="mb-2">
              We recomend:
            </div>

            <ul class="mb-0 pb-0">
              <li>Use logo with files extensions: {{ acceptedFormats }}</li>
              <li>Use files smaller than 2MB</li>
              <li>Big images will be shrinked to size 100px * 260px</li>
            </ul>
          </app-disclaimer>

          <div>
            <app-yes-no-control
              label="Insert Logo in the Annual Statement Cover Letter"
              formControlName="insertLogoInAnnualStatementCoverLetter"
            />
          </div>

          <div>
            <app-yes-no-control
              label="Add a Cover Page on ASIC forms"
              formControlName="addCoverPageOnAsicForms"
            />
          </div>
        </div>
      </form>
    }
  </div>
</div>

<ng-template #previewTemplate let-logo="logo" let-footerText="footerText">
  @if (this.previewVariantControl.value === 1) {
    <app-shadow-dom-viewer [customStyle]="customStyle" [htmlContent]="htmlContent()"/>
  } @else {
    <div class="template">
      <div class="logo-wrapper">
        @if (logo) {
          <img
            class="logo-image"
            alt="Organisation Logo"
            [src]="logo"
          >
        }
      </div>

      <p style="text-align: end">DOCUMENT LOGO PREVIEW</p>
      <p style="text-align: end; flex-grow: 1">LOGO TEST</p>

      @if (footerText) {
        <div class="footer-text">{{ footerText }}</div>
      }
    </div>
  }
</ng-template>
